/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StarClubChallengePackTile',[
		'lodash',
		'pixi',
		'absolute/stringmanager',
		'absolute/screenmetrics',
		'absolute/coords',
		'absolute/spriteutils',
		'MenuUI/MenuTile',
		'MenuUI/Label',
		'Managers/StatManager',
		'absolute/particleemitter',
		'absolute/audiomanager', 'absolute',
		'Managers/ScaleManager'
	],
	function (_, PIXI, _s, ScreenMetrics, Coords, SpriteUtils, MenuTile, Label, StatManager, ParticleEmitter, AudioManager, Absolute, ScaleManager) {
		"use strict";


		var StarClubChallengePackTile = function (config, challengePack, menu) {
			var defaultConfig = {};
			this.initStarClubChallengePackTile(_.extend(defaultConfig, config), challengePack, menu);
		};

		StarClubChallengePackTile.constructor = StarClubChallengePackTile;
		StarClubChallengePackTile.prototype = Object.create(MenuTile.prototype);

		StarClubChallengePackTile.prototype.initStarClubChallengePackTile = function (config, challengePack, menu) {


			MenuTile.call(this, config);
			this.challengePack = challengePack;
			this.menu = menu;


			// overlay

			if (this.label.text == "EasyText" || this.label.text == "MediumText" || this.label.text == "HardText" || this.label.text == "ExpertText") {
			}

			this.titleOverlay = PIXI.Sprite.fromFrame("star_club/rect_SC_title.png");
			this.titleOverlay.y = this.height - this.titleOverlay.height;

			this.addChild(this.titleOverlay);


			var starProgressLabelConfig = {
				icon: "star_club/sc_tile_info_star.png",
				text: '',
				letterStyle: {
					font: ScreenMetrics.getResScale() * 22 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#FDEF39',
					tint: 0xFDEF39,
					align: 'left'
				}
			};

			starProgressLabelConfig.text = this.challengePack.NumStarsEarned + "/" + this.challengePack.NumStars;
			this.starProgressLabel = new Label(starProgressLabelConfig);
			this.starProgressLabel.x = this.titleOverlay.width - this.starProgressLabel.width - Coords.x(10);
			this.starProgressLabel.y = this.titleOverlay.height - this.starProgressLabel.height - Coords.y(5);
			this.titleOverlay.addChild(this.starProgressLabel);

			this.label.x = Coords.x(10);
			this.label.y = Coords.y(12);

			this.titleOverlay.addChild(this.label);


			if (challengePack.PriceOfUnlocking > 0 && !challengePack.Unlocked) {

				this.lockedOverlay = PIXI.Sprite.fromFrame("star_club/rect_SC_locked.png");

				this.lockGroup = new PIXI.DisplayObjectContainer();

				var starsLabel = new Label(
					{
						icon: "star_club/sc_tile_info_star.png",
						text: challengePack.PriceOfUnlocking.toString(),
						letterStyle: {
							font: ScreenMetrics.getResScale() * 30 + 'px Arial',
							fontFamily: 'segoe',
							fill: '#FFFFFF',
							tint: 0xFFFFFF,
							align: 'center'
						}
					});

				starsLabel.x = (this.lockedOverlay.width - starsLabel.width) / 2;

				this.lockGroup.addChild(starsLabel);

				var toUnlockLabel = new Label(
					{
						icon: null,
						text: _s("starClub.toUnlock"),
						letterStyle: {
							font: ScreenMetrics.getResScale() * 30 + 'px Arial',
							fill: '#FFFFFF',
							fontFamily: 'segoe',
							tint: 0xFFFFFF,
							align: 'center'
						},
						maxWidth: Absolute.Coords.x(300)
					});
				toUnlockLabel.x = (this.lockedOverlay.width - toUnlockLabel.width) / 2;
				toUnlockLabel.y = starsLabel.y + starsLabel.height + Coords.y(5);

				this.lockGroup.addChild(toUnlockLabel);

				this.lockIcon = PIXI.Sprite.fromFrame("star_club/SC_challenge_lock.png");
				this.lockIcon.x = (this.lockedOverlay.width - this.lockIcon.width) / 2;
				this.lockIcon.y = toUnlockLabel.y + toUnlockLabel.height + Coords.y(15);

				this.lockGroup.addChild(this.lockIcon);

				this.lockGroup.x = 0;
				this.lockGroup.y = (this.lockedOverlay.height - this.lockGroup.height) / 2;
				this.lockedOverlay.addChild(this.lockGroup);

				this.addChild(this.lockedOverlay);
			}

			this.updateCrown();
			this.initTooltip();
			window.addEventListener('mousedown', function (event) {
				if (StarClubChallengePackTile.lastInfoBox) {
					StarClubChallengePackTile.lastInfoBox.visible = false;
					if (this.menu.challengePackMenu.children.indexOf(StarClubChallengePackTile.lastInfoBox) !== -1)
						this.menu.challengePackMenu.removeTooltip(StarClubChallengePackTile.lastInfoBox);
				}
			}.bind(this));
		};

		StarClubChallengePackTile.prototype.updateStarProgress = function () {
			this.starProgressLabel.setText(this.challengePack.NumStarsEarned + "/" + this.challengePack.NumStars);
			this.starProgressLabel.x = this.titleOverlay.width - this.starProgressLabel.width - Coords.x(10);
			this.starProgressLabel.y = this.titleOverlay.height - this.starProgressLabel.height - Coords.y(10);
		};

		StarClubChallengePackTile.prototype.handleClick = function () {
			if (this.challengePack.Unlocked) {
				MenuTile.prototype.handleClick.call(this);
			} else {
				if (StatManager.GetValue("SCGlobalStarsEarned") >= this.challengePack.PriceOfUnlocking) {
					this.animateUnlock();
				} else {
					if (StarClubChallengePackTile.lastInfoBox) {
						StarClubChallengePackTile.lastInfoBox.visible = false;
					}
					StarClubChallengePackTile.lastInfoBox = this.infoBoxContainer;
					this.infoBoxContainer.openBox();
					this.interactive = true;
				}
			}
		};

		StarClubChallengePackTile.prototype.animateUnlock = function () {

			this.challengePack.Unlocked = true;
			this.unlockAnimation = SpriteUtils.loadMovieClip("unlock_animation/unlocking-animation_", 30, 1);
			this.unlockAnimation.animationSpeed = 30 / 60;
			this.unlockAnimation.loop = false;
			this.unlockAnimation.scale.x = this.unlockAnimation.scale.y = 1.45;

			this.unlockAnimation.x = Coords.y(3) + (this.lockedOverlay.width - this.unlockAnimation.width) / 2;
			this.unlockAnimation.y = Coords.y(65) + (this.lockedOverlay.width - this.unlockAnimation.height) / 2;

			this.lockGroup.removeChild(this.lockIcon);
			this.lockedOverlay.addChild(this.unlockAnimation);

			this.unlockAnimation.onComplete = function () {
				window.setTimeout(function () {
					this.removeChild(this.lockedOverlay);
					this.animateUnlockComplete = true;
				}.bind(this), 1000);
				this.interactive = true;
			}.bind(this);

			AudioManager.playSound('sc_starFlying_isolated');
			this.menu.game.menuBar.starCountDisplay.triggerStarAnimation(this, true, function () {
				AudioManager.playSound('sc_starUnlock');
				this.unlockAnimation.gotoAndPlay(0);
				this.menu.game.menuBar.starCountDisplay.triggerStarAnimation(this, false);
			}.bind(this));


		};

		StarClubChallengePackTile.prototype.updateCrown = function (animate) {
			if (this.challengePack.NumStarsEarned == this.challengePack.NumStars && !this.crown) {
				// animate the crown
				var self = this;
				if (!this.crown) {
					this.crown = PIXI.Sprite.fromFrame('star_club/crown.png');
					this.addChild(this.crown);
				}

				this.crown.anchor.x = this.crown.anchor.y = 0.5;
				this.crown.x = this.width / 2;
				this.crown.y = this.height / 2;
				this.crown.alpha = 1;
				this.crown.scale.x = this.crown.scale.y = 1;

				if (animate) {

					AudioManager.playSound('CrownAppearance');

					var textures1 = [PIXI.Texture.fromFrame('particle_glow_yellow.png')],
						textures2 = [PIXI.Texture.fromFrame('Star_orng_dot.png'), PIXI.Texture.fromFrame('Star_yellow_dot.png'), PIXI.Texture.fromFrame('Star_yel.png')],
						particleOptions1 = {
							rate: {numpan: {a: 8, b: 12, center: true}, timepan: {a: 0.01, b: 0.002, center: null}},
							mass: 1,
							rotation: {a: [0, 1], b: [0, 3], style: 'add'},
							velocity: [0.2, 0.5, 1],
							alpha: {a: 1, b: 0},
							scale: {a: [0.5, 1], b: 0, center: null},
							gravity: 0,
							life: {a: 1, b: 1.5, center: null},
							radius: 1,
							crossZone: null,
							randomDrift: null
						},
						particleOptions2 = {
							rate: {numpan: {a: 2, b: 4, center: true}, timepan: {a: 0.01, b: 0.002, center: null}},
							mass: 1,
							rotation: {a: [0, 1], b: [0, 3], style: 'add'},
							velocity: [0.5, 1],
							alpha: {a: 0.5, b: 0},
							scale: {a: [0.3, 0.3, 0.5], b: 0, center: null},
							gravity: 0,
							life: {a: 1, b: 2, center: null},
							radius: 1,
							crossZone: null,
							randomDrift: null
						},
						emitter1 = new ParticleEmitter(this.menu.ui, textures1, particleOptions1),
						emitter2 = new ParticleEmitter(this.menu.ui, textures2, particleOptions2),
						self = this;

					this.particleLayer.addChild(emitter1);
					this.particleLayer.addChild(emitter2);

					emitter1.x = emitter2.x = this.crown.x;
					emitter1.y = emitter2.y = this.crown.y;

					this.crown.alpha = 0;

					emitter1.start();

					var crownAlpha = new TWEEN.Tween({alpha: 0})
						.easing(TWEEN.Easing.Exponential.In)
						.to({alpha: 1}, 1200)
						.onStart(function () {
							window.setTimeout(function () {
								emitter1.stop();
							}, 600)
						})
						.onUpdate(function () {
							self.crown.alpha = this.alpha;
						})
						.start();

					var crownBounce = new TWEEN.Tween({scale: 1})
						.delay(500)
						.easing(TWEEN.Easing.Elastic.Out)
						.to({scale: [1.5, 1]}, 1500)
						.onStart(function () {
							window.setTimeout(function () {
								emitter2.start();
							}, 700);
						})
						.onUpdate(function () {
							self.crown.scale.x = self.crown.scale.y = this.scale;
						})
						.onComplete(function () {
							emitter2.stop();
						})
						.start();
				}
			}
		};

		StarClubChallengePackTile.prototype.onShow = function () {
			if (!this.particleLayer) {
				this.particleLayer = new PIXI.DisplayObjectContainer();
				this.addChild(this.particleLayer);
			}
			if (this.crown) {
				this.crown.alpha = 1;
				this.crown.scale.x = this.crown.scale.y = 1;
				this.addChild(this.crown);
			}
			this.updateStarProgress();
			this.updateCrown(true);
			if (this.challengePack.Unlocked && !this.animateUnlockComplete && StatManager.GetValue("SCGlobalStarsEarned") >= this.challengePack.PriceOfUnlocking) {
				this.removeChild(this.lockedOverlay);
			}
			this.interactive = true;
		};

		StarClubChallengePackTile.prototype.onHide = function () {
			if (this.particleLayer) {
				this.removeChild(this.particleLayer);
				this.particleLayer = null;
			}

			this.interactive = false;
		};

		StarClubChallengePackTile.prototype.initTooltip = function () {
			this.infoBoxContainer = new PIXI.DisplayObjectContainer();
			var infoBox = new PIXI.Graphics(),
				letterStyle = {
					font: ScreenMetrics.getResScale() * 19 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left',
					wordWrap: true,
					wordWrapWidth: this.width
				},
				infoBoxText = new PIXI.Text(_s("starClub.tooltip"), letterStyle);
			infoBox.beginFill(0x000000);
			infoBox.lineStyle(3, 0xffffff, 1);
			infoBox.drawRect(0, 0, this.width + Coords.x(14), infoBoxText.height + Coords.y(10));
			infoBox.endFill();
			infoBoxText.x = Coords.x(7);
			infoBoxText.y = Coords.y(10);
			this.infoBoxContainer.addChild(infoBox);
			this.infoBoxContainer.addChild(infoBoxText);
			this.infoBoxContainer.visible = false;
			this.infoBoxContainer.x = this.width / 2 - this.infoBoxContainer.width / 2;
			this.currentWidth = this.infoBoxContainer.width;
			this.currentHeight = this.infoBoxContainer.height;
			this.onOpenBox(this.infoBoxContainer, infoBoxText);
		};

		StarClubChallengePackTile.prototype.onOpenBox = function (infoBoxContainer, infoBoxText) {
			var self = this;
			this.infoBoxContainer.openBox = function () {

				var earnedStars = StatManager.GetValue("SCGlobalStarsEarned");
				infoBoxContainer.visible = true;
				infoBoxText.text = infoBoxText.text.replace('$$$', this.challengePack.PriceOfUnlocking - earnedStars);
				infoBoxText.updateText();
				this.setTooltipPosition();
				if (this.menu.challengePackMenu.children.indexOf(infoBoxContainer) === -1) {
					this.menu.challengePackMenu.addTooltip(infoBoxContainer);
				}
				if (infoBoxContainer.visible) {
					new TWEEN.Tween({alpha: 0})
						.easing(TWEEN.Easing.Cubic.InOut)
						.to({alpha: 1}, 350)
						.onUpdate(function (p) {
							infoBoxContainer.alpha = this.alpha;
						})
						.start();
					if (this.hideTimeout) clearTimeout(this.hideTimeout);
					this.hideTimeout = window.setTimeout(function () {
						self.hideTooltip(infoBoxContainer, self);
					}.bind(this), 3000);
				}
			}.bind(this);

		};

		StarClubChallengePackTile.prototype.hideTooltip = function (infoBoxContainer, self) {
			new TWEEN.Tween({alpha: 1})
				.easing(TWEEN.Easing.Cubic.InOut)
				.to({alpha: 0}, 350)
				.onUpdate(function () {
					infoBoxContainer.alpha = this.alpha;
				})
				.onComplete(function () {
					infoBoxContainer.visible = false;
					if (self.menu.challengePackMenu.children.indexOf(this.infoBoxContainer) !== -1) self.menu.challengePackMenu.removeTooltip(infoBoxContainer);
				})
				.start()
		};

		StarClubChallengePackTile.prototype.resizeInfoBoxContainer = function () {
			this.setTooltipPosition();
			this.infoBoxContainer.width = this.currentWidth * this.menu.challengePackMenu.pageGenerator.cardScale;
			this.infoBoxContainer.height = this.currentHeight * this.menu.challengePackMenu.pageGenerator.cardScale;
		};

		StarClubChallengePackTile.prototype.setTooltipPosition = function () {
			var y = 0;
				y = this.y - this.infoBoxContainer.height;
				if(this.menu.container.y + this.menu.challengePackMenu.y + y + this.menu.scrollable.y < this.menu.game.menuBar.y + this.menu.game.menuBar.height + Absolute.Coords.y(100)) {
						y = this.y + this.height * this.menu.challengePackMenu.pageGenerator.cardScale + Absolute.Coords.y(15);
				}
			this.infoBoxContainer.x = this.x + (this.width * this.menu.challengePackMenu.pageGenerator.cardScale) / 2 - this.infoBoxContainer.width / 2;
			this.infoBoxContainer.y = y;
		};
		return StarClubChallengePackTile;
	});

